import { ToastContainer } from "@stenajs-webui/modal";
import type { CSSProperties, FC } from "react";
import { useSelector } from "react-redux";
import { Slide } from "react-toastify";

import { Portal } from "../../../common-ui/Portal";
import { zIndices } from "../../../common/zIndices";
import { getIsAnyTourRunningOrModalShowing } from "../../../services/tour/tourReducer";

const toastRootStyle: CSSProperties = {
  position: "fixed",
  top: 0,
  right: 0,
  zIndex: zIndices.toasterWrapper,
  maxHeight: "100dvh",
  overflowY: "auto",
  overflowX: "hidden",
  pointerEvents: "none",
  scrollbarWidth: "none",
};

interface NotificationToastContainerProps {
  isNotificationCenterOpen: boolean;
}

export const NotificationToastContainer: FC<
  NotificationToastContainerProps
> = ({ isNotificationCenterOpen }) => {
  const isAnyTourRunningOrModalShowing = useSelector(
    getIsAnyTourRunningOrModalShowing,
  );
  const hidden = isNotificationCenterOpen || isAnyTourRunningOrModalShowing;

  if (hidden) {
    return null;
  }

  return (
    <Portal target={"#toast-root"}>
      <div className={"t_toast"} style={toastRootStyle}>
        <ToastContainer
          transition={Slide}
          closeButton={false}
          hideProgressBar
          newestOnTop
          draggable={false}
          style={{
            position: "static",
            width: 356,
            padding: "8px",
            pointerEvents: "none",
            ["--toastify-toast-width" as string]: "340px",
          }}
          toastStyle={{
            flexShrink: 0,
            pointerEvents: "auto",
            padding:
              "var(--swui-metrics-spacing) calc(var(--swui-metrics-indent) * 2)",
            borderRadius: "var(--swui-border-radius)",
            boxShadow: "var(--swui-shadow-popover)",
          }}
        />
      </div>
    </Portal>
  );
};
